<template>
  <div>
    <el-card v-loading="loading">
      <div slot="header">
        <el-row>
          <el-col :span="12"><strong><i style="color:#409eff" class="el-icon-info"/>{{title}}</strong></el-col>
          <el-col :span="12" style="text-align:right">
            <el-button
              v-if="createButton"
              style
              type="success"
              icon="el-icon-plus"
              @click="openDia(null)"
            >创建{{resource}}</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <slot name="search" />
      </div>
      <div>
        <el-table :border="border" :data="items">
          <slot />
        </el-table>
      </div>
      <el-divider />
      <div style="text-align:center">
        <el-pagination
          @size-change="changePageSize"
          @current-change="changeCurrent"
          :current-page="pagination.page"
          :page-sizes="[20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialog.show"
      :title="dialog.title?`编辑[${dialog.title}]`:`创建新${resource}`"
    >
      <div>
        <el-form ref="f" :model="dialog.model" :rules="rules">
          <slot name="form" :data="dialog.model" />
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.show = false" v-loading="loading">取 消</el-button>
        <el-button type="primary" @click="save" v-loading="loading">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    pageModel: { required: true, type: Object },
    title: { required: true, type: String },
    resource: { required: true, type: String },
    titleKey: { default: "title" },
    rules: { default: {} },
    idKey: { default: "id" },
    createButton: { default: true },
    border: { default: false }
  },
  data() {
    return {
      items: [],
      loading: false,
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      condition: {},
      dialog: {
        show: false,
        id: null,
        title: null,
        model: {}
      }
    };
  },
  mounted() {
    this.getTable();
  },
  methods: {
    getTable() {
      let _this = this;
      this.loading = true;
      this.pageModel
        .list(this.pagination.page, this.pagination.pageSize, this.condition)
        .then(res => {
          _this.items = res.data.list;
          _this.pagination.total = res.data.total;
          _this.loading = false;
        })
        .catch(e => {
          _this.$message({
            type: "error",
            text: e
          });
          _this.loading = false;
        });
    },
    changeCurrent(val) {
      this.pagination.page = val;
      this.getTable();
    },
    changePageSize(val) {
      this.pagination.pageSize = val;
      this.getTable();
    },
    openDia(item) {
      this.dialog.model = {};
      this.dialog.id = null;
      this.dialog.title = null;
      if (item) {
        this.dialog.title = item[this.titleKey];
        this.dialog.id = item[this.idKey];
        this.dialog.model = Object.assign({}, item);
      }

      this.dialog.show = true;
    },
    closeDia() {
      this.dialog.show = false;
    },
    resetSearch() {
      this.$refs.search.resetFields();
    },
    confirmSearch(cond) {
      this.condition = cond;
      this.getTable();
    },
    del(item) {
      let _this = this;
      this.$confirm(
        `您确定要删除[${item[this.titleKey]}]${
          this.resource
        }吗？此操作不可逆！`,
        "提示：",
        {
          confirmButtonText: "删 除",
          cancelButtonText: "取 消"
        }
      )
        .then(() => {
          _this.loading = true;
          _this.pageModel
            .del(item[_this.idKey])
            .then(() => {
              _this.$message({ type: "success", message: "操作成功" });
              _this.loading = false;
              _this.getTable();
            })
            .catch(e => {
              _this.$message({ type: "error", message: e });
              _this.loading = false;
            });
        })
        .catch(() => {});
    },
    save() {
      let _this = this;
      this.$refs.f.validate(valid => {
        if (valid) {
          _this.loading = true;
          let curd = null;
          if (_this.dialog.id) {
            curd = _this.pageModel.update(_this.dialog.id, _this.dialog.model);
          } else {
            curd = _this.pageModel.create(_this.dialog.model);
          }

          curd
            .then(res => {
              _this.loading = false;
              _this.closeDia();
              _this.getTable();
              _this.$message({
                type: "success",
                message: "操作成功"
              });
            })
            .catch(e => {
              _this.loading = false;
              _this.$message({
                type: "error",
                message: e
              });
            });
        }
      });
    }
  }
};
</script>

<style>
</style>